import React, { FC } from 'react';
import { EngagementsListPage } from './engagements-list.page';
import { useGetAllProvidersQuery } from '../../../../store/api/providers.api';
import {
	useGetAllFamiliesByDistrictIdQuery,
	useGetChildrenByDistrictIdQuery,
} from '../../../../store/api/families.api';
import { useGetAllFieldsQuery } from '../../../../store/api/customRequirements.api';
import { useGetAllEngagementStatusesQuery, useGetEngagementStatusesQuery } from '../../../../store/api/engagements.api';
import { EngagementColumnName } from '../../hooks/table-columns/engagements-table-columns.hook';
import { AllowedEngagementActions } from '../../components/engagements-table/engagements-table-actions.component';

export const EngagementsListAdminLevelPage: FC = () => {
	const { data: providersList } = useGetAllProvidersQuery({});
	const { data: familiesList } = useGetAllFamiliesByDistrictIdQuery({});
	const { data: childrenList } = useGetChildrenByDistrictIdQuery({});
	const { data: fieldsList } = useGetAllFieldsQuery({});
	const { data: statusesList } = useGetAllEngagementStatusesQuery();
	const engagementColumnsList: EngagementColumnName[] = [
		'district',
		'title',
		'customId',
		'provider',
		'language',
		'duration',
		'status',
		//'surveyStatus',
		'actions',
	];
	const allowedEngagementActions: AllowedEngagementActions[] = ['view'];

	return (
		<EngagementsListPage
			permission={{ read: true }}
			isAdminRoute={true}
			engagementColumnsList={engagementColumnsList}
			allowedEngagementActions={allowedEngagementActions}
			providersList={providersList}
			familiesList={familiesList}
			childrenList={childrenList}
			fieldsList={fieldsList}
			statusesList={statusesList}
		/>
	);
};
